import {
  Action, getModule, Module, VuexModule,
} from 'vuex-module-decorators';
import { validateOrReject } from 'class-validator';
import FileSaver from 'file-saver';
import { classToPlain } from 'class-transformer';
import repositoryFactory from '@/api/factory';

// eslint-disable-next-line
import store from '@/store';
import { PAYMENT_ORDERS } from '@/constants/repository';
import PaymentOrdersRepository, {
  PaymentOrder as PaymentOrderModel,
  PaymentOrder,
} from '@/api/payment-orders';

const paymentOrdersRepository = repositoryFactory
  .get<typeof PaymentOrdersRepository>(PAYMENT_ORDERS);

@Module({
  name: PAYMENT_ORDERS,
  namespaced: true,
  store,
  dynamic: true,
})
class PaymentOrdersModule extends VuexModule {
  paymentOrder = PaymentOrderModel.from('Petračić-projekt d.o.o.');

  @Action({ rawError: true })
  async generatePaymentOrder(paymentOrder: PaymentOrder) {
    try {
      await validateOrReject(paymentOrder);
    } catch (e) {
      throw new Error('Invalid payment order');
    }

    const { data } = await paymentOrdersRepository.post(classToPlain(paymentOrder) as PaymentOrder);

    const blob = new Blob([data.content], { type: 'text/xml;charset=utf-8' });

    FileSaver.saveAs(blob, data.filename);
  }
}

export default getModule(PaymentOrdersModule);
